// @ts-expect-error - Import needs esModuleInterop flag
import { useTranslation } from '@contexts/translation'
import { Typography } from '@mui/material'
import React from 'react'

/**
 * NoPermissionPage
 * Component shown when the user doesn't have permission to access a page
 */
const NoPermissionPage = (): JSX.Element => {
  const { dictionary } = useTranslation()

  // Ensure the string access is typed properly
  const noPermissionText: string = dictionary.no_page_permission as string

  return (
    <div
      style={{
        width: '100%',
        height: '90vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography
        variant="h5"
        data-testid="Typography-1fb3e30e-8c22-4e95-8ec4-7d391fc25183"
      >
        {noPermissionText}
      </Typography>
    </div>
  )
}

export default NoPermissionPage
